<!-- <ng-container *ngIf="insightsSeriesChartDataLoaded">
<p-chart type="line" height="300px" [data]="chartDataItems" [options]="insightsSeriesChartOptions"></p-chart>
</ng-container> -->
<!-- <div class="chart-container">
<div *ngIf="insightsSeriesChartDataLoaded" class="total-sales">
  Total Sales: {{ calculateTotalSales()  | currency:'USD':'symbol':'1.2-2' }}
</div>
Chart
<div *ngIf="insightsSeriesChartDataLoaded">
  <p-chart [type]="'line'" height="300px" [data]="chartDataItems" [options]="insightsSeriesChartOptions"></p-chart>
</div>
</div> -->
<div class="row mt-2">
  <!-- Duration Dropdown -->
  <div class="col-6 col-md-3 p-4 duration">
    <p-dropdown [options]="salesDurationOptions" [(ngModel)]="selectedArtristProductDetailDuration"
      [showClear]="false" [placeholder]="'artistInsightsChart.selectSalesDuration' | transloco"
    (onChange)="onSalesDurationChange($event)"></p-dropdown>
  </div>

  <!-- Spacer Column -->
  <div class="col-12 col-md-9">
    <!-- You can add content here if needed -->
  </div>
</div>

<div class="p-3">
  @if (insightsSeriesChartDataLoaded) {
    <div class="total-sales mb-3">
      @if (insightsSeriesData.SeriesName == 'Total Sales') {
        {{insightsSeriesData.SeriesName}}: {{ calculateTotalSales() | currency:'USD':'symbol':'1.2-2' }}
      }
      @if (insightsSeriesData.SeriesName == 'Total Artworks Sold') {
        {{insightsSeriesData.SeriesName}}: {{ calculateTotalSales() | currency:'USD':'symbol':'1.2-2' }}
      }
      @if (insightsSeriesData.SeriesName == 'Average Turnover Times') {
        {{insightsSeriesData.SeriesName}}: {{ calculateTotalSales() }}
      }
    </div>
  }

  <!-- Chart -->
  @if (insightsSeriesChartDataLoaded) {
    <div>
      <p-chart id="{{selectedTabIndex}}" [type]="'line'" height="300px" [data]="chartDataItems" [options]="insightsSeriesChartOptions"></p-chart>
    </div>
  }
</div>
